import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { expireAdminSession, isAdminLoginHandoff, isAdminSessionPath, storedAdminToken, tokenExpiry } from '../../utils/adminSession';

export default function AdminSessionMonitor() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!isAdminSessionPath(pathname) || pathname === '/superadmin/login' || isAdminLoginHandoff(pathname, search)) return undefined;
    let timer;
    let previous = storedAdminToken();
    const check = () => {
      clearTimeout(timer);
      const token = storedAdminToken();
      if (!token) {
        if (previous) expireAdminSession(previous);
        return;
      }
      previous = token;
      const expires = tokenExpiry(token);
      if (expires === null) return;
      const remaining = expires - Date.now();
      if (remaining <= 0) { expireAdminSession(token); return; }
      timer = setTimeout(check, Math.min(remaining, 2147483647));
    };
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    const onStorage = event => { if (!event.key || ['plateos_token', 'token'].includes(event.key)) check(); };
    check();
    window.addEventListener('focus', check);
    window.addEventListener('storage', onStorage);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', check);
      window.removeEventListener('storage', onStorage);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [pathname, search]);
  return null;
}
